<template>
  <v-container fluid id="print" ref="printRef" style="">
    <div v-if="loanApplication && loanApplication.expenses">
      <v-row justify="center" no-gutters>
        <img
          class="pb-2"
          src="@/assets/Bradbury_logo_2022.jpg"
          style="max-height: 80px"
        />
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <span class="text-body-2 font-weight-bold"
            >PRE-AGREEMENT STATEMENT AND QUOTATION</span
          >
        </v-col>
        <v-col cols="6" class="text-center">
          <span class="text-caption"
            >These quotations are valid for 5 business days</span
          >
        </v-col>
      </v-row>
      <v-row no-gutters>
        <span class="text-body-2 font-weight-bold">
          PART 1: THE CREDIT PROVIDER OFFERS THE FOLLOWING AVAILABLE LOANS:
        </span>
      </v-row>
      <v-row no-gutters>
        <span class="text-caption">Maximum Repayment: ± 25% of Salary</span>
      </v-row>
      <v-row no-gutters>
        <v-card outlined>
          <v-data-table
            disable-sort
            :items="[loanApplication.loanType]"
            :headers="loanTypeHeaders"
            hide-default-footer
            no-data-text="No loan selected"
            class="grey lighten-4"
          >
            <template v-slot:[`item.randValue`]="{ item }">
              {{ "R" + item.randValue.toFixed(2) }}
            </template>
            <template v-slot:[`item.adminFee`]="{ item }">
              {{ "R" + item.adminFee.toFixed(2) }}
            </template>
            <template v-slot:[`item.totalInterest`]="{ item }">
              {{ "R" + item.totalInterest.toFixed(2) }}
            </template>
            <template v-slot:[`item.creditLifeFee`]="{ item }">
              {{ "R" + item.creditLifeFee.toFixed(2) }}
            </template>
            <template v-slot:[`item.serviceCharge`]="{ item }">
              {{ "R" + item.serviceCharge.toFixed(2) }}
            </template>
            <template v-slot:[`item.payment`]="{ item }">
              {{ "R" + item.payment.toFixed(2) }}
            </template>
            <template v-slot:[`item.totalPayment`]="{ item }">
              {{ "R" + item.totalPayment.toFixed(2) }}
            </template></v-data-table
          >
        </v-card>
      </v-row>
      <v-row no-gutters class="pt-3">
        <span class="text-body-2 font-weight-bold"
          >PART 2: EMPLOYER / COMPANY:</span
        >
      </v-row>
      <v-row no-gutters>
        <span style="text-align: justify; font-size: 7px; line-height: 11px">
          The Company agrees: To deduct the number of repayments from the
          Applicant's salary monthly & pay same over to the Credit Provider or
          its nominee. In the event of the employee leaving the Company, the
          outstanding loan balance becomes immediately due. <br />The Employee
          hereby authorises the Company to deduct the agreed monthly instalment
          from their salary each month until the full loan amount, including any
          applicable fees and interest, has been repaid. The Employee hereby
          authorises the Employer to deduct from any remuneration due to them,
          including but not limited to bonuses, overtime, leave pay, and/or any
          other accrued benefits, any amounts owing under this loan agreement
          until the debt is fully settled. If, further to this, there is still
          an outstanding balance, we hereby acknowledge Bradbury Finance will
          process the deduction via debit order on my bank account nominated.
        </span>
      </v-row>
      <v-row no-gutters class="mt-4">
        <v-col cols="3" class="pr-1">
          <v-text-field
            dense
            v-model="loanApplication.company.name"
            label="Company:"
            type="string"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="loanApplication.company.pastelCode"
            label="Company Code:"
            type="string"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="pr-1">
          <v-text-field
            dense
            v-model="loanApplication.company.region"
            label="Region:"
            type="string"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="loanApplication.company.branch"
            label="Branch:"
            type="string"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <span class="text-body-2 font-weight-bold"
            >MONTHLY SHORT TERM CREDIT TRANSACTION</span
          >
        </v-col>
        <v-col cols="6">
          <span class="text-caption">
            The Applicant / Consumer / Employee hereafter referred to as the
            Applicant
          </span>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col cols="6">
          <span class="text-body-2 font-weight-bold"
            >PART 3: The Applicant / Consumer / Employee</span
          >
        </v-col>
        <v-col cols="6">
          <span class="text-body-2 font-weight-bold"
            >The Applicant's Spouse:</span
          >
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-4">
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.employee.name"
            label="FIRST NAMES:"
            type="string"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.spouseName"
            label="FIRST NAMES:"
            type="string"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.employee.surname"
            label="SURNAME:"
            type="string"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.spouseSurname"
            label="SURNAME:"
            type="string"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.employee.title"
            label="TITLE:"
            type="string"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.spouseTitle"
            label="TITLE:"
            type="string"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.employee.idNumber"
            label="ID/Passport Number:"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.spouseIdNumber"
            label="ID/Passport Number:"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.employee.cell"
            label="CONTACT TELL No.:"
            type="number"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.spouseCell"
            label="CONTACT TELL No.:"
            type="number"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.employee.address"
            label="ADDRESS:"
            type="string"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.spouseAddress"
            label="ADDRESS:"
            type="string"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.employee.email"
            label="EMAIL:"
            type="string"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.spouseEmail"
            label="EMAIL:"
            type="string"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="loanApplication.employeeClockNumber"
            label="PERSONNEL / CLOCK NUMBER:"
            type="string"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-checkbox
          v-model="loanApplication.consent"
          readonly
          :class="
            screenWidth < 447
              ? 'mb-15'
              : screenWidth < 565
              ? 'mb-10'
              : screenWidth < 1027
              ? 'mb-5'
              : ''
          "
          ><template #label>
            <span style="font-size: 7px; line-height: 11px"
              >I hereby give consent that, at my request, Bradbury Finance Pty
              Ltd may forward my necessary details to another service provider
              in the event they cannot assist me.</span
            >
          </template>
        </v-checkbox>
      </v-row>
      <v-row no-gutters style="page-break-before: always">
        <v-col cols="6">
          <span class="text-body-2 font-weight-bold"
            >PART 4: BANK DETAILS OF APPLICANT</span
          >
        </v-col>
        <v-col cols="6">
          <span class="red--text text-caption">
            (This information is very important for payment into Applicant's
            account)
          </span>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-4">
        <v-col cols="3">
          <v-text-field
            dense
            v-model="loanApplication.bankName"
            label="NAME OF BANK:"
            type="string"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="loanApplication.branchName"
            label="BRANCH NAME:"
            type="string"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="loanApplication.branchNumber"
            label="BRANCH No.:"
            type="number"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="loanApplication.accountNumber"
            label="ACCOUNT No.:"
            type="number"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="loanApplication.accountName"
            label="ACCOUNT NAME:"
            type="string"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="loanApplication.grossSalary"
            label="GROSS SALARY:"
            type="number"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="loanApplication.nettSalary"
            label="NETT SALARY:"
            type="number"
            readonly
            class="pr-1"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="loanApplication.totalLeft"
            label="TOTAL LEFT:"
            type="number"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <v-row no-gutters>
            <span
              >ARE YOU UNDER ADMINISTRATION ?
              <span class="font-weight-bold"
                >{{ loanApplication.underAdministration ? "YES" : "NO" }}
              </span>
            </span>
          </v-row>
          <v-row no-gutters>
            <span
              >IS THIS AN EMERGENCY LOAN ?
              <span class="font-weight-bold"
                >{{ loanApplication.isThisEmergencyLoan ? "YES" : "NO" }}
              </span>
            </span>
          </v-row>
          <v-row no-gutters>
            <span
              >ARE YOU UNDER DEBT REVIEW ?
              <span class="font-weight-bold"
                >{{ loanApplication.underDeptReview ? "YES" : "NO" }}
              </span>
            </span>
          </v-row>
          <v-row
            no-gutters
            v-if="
              loanApplication.loanPurpose && !loanApplication.loanPurposeOther
            "
            class="mt-1"
            style="margin-bottom: -12px"
          >
            <v-select
              v-model="loanApplication.loanPurpose"
              :items="Object.keys(loanPurposes)"
              return-object
              label="WHAT IS THE PURPOSE OF THE LOAN ?"
              readonly
              class="pr-1"
            ></v-select>
          </v-row>
          <v-row
            no-gutters
            v-else-if="loanApplication.loanPurposeOther"
            class="mt-4"
          >
            <v-text-field
              dense
              v-model="loanApplication.loanPurposeOther"
              label="OTHER LOAN PURPOSE:"
              type="string"
              readonly
              class="pr-1"
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-card outlined>
            <v-data-table
              id="ExpenseTable"
              dense
              :items="loanApplicationExpenses"
              :headers="expenseHeaders"
              hide-default-footer
              :items-per-page="20"
              no-data-text="No expenses added yet"
              class="grey lighten-4"
            ></v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <span style="font-size: 7px; line-height: 11px">
          I agree that the Credit Provider may request and obtain any financial
          information about me on record from the National Credit Register and
          Credit Bureau.
        </span>
      </v-row>
      <v-row no-gutters style="padding-top: 18px; margin-bottom: -8px">
        <v-col cols="4" class="pr-1">
          <v-row no-gutters style="margin-top: -13px; margin-left: 10px">
            <span class="text-caption" style="color: rgba(0, 0, 0, 0.6)"
              >Signature:</span
            >
          </v-row>
          <div
            v-if="doesSignatureImageExist && !signaturePDF"
            style="
              max-height: 43px;
              min-height: 43px;
              max-width: -webkit-fill-available;
              margin-left: 70px;
              margin-top: -20px;
            "
          >
            <img
              :src="this.signatureImage"
              style="max-height: inherit; max-width: -webkit-fill-available"
            />
          </div>
          <span v-else-if="signaturePDF" class="text-caption"
            >Signature is a PDF and cannot be viewed here.</span
          >
          <div
            style="
              position: relative;
              z-index: 999;
              border-bottom-style: solid;
              border-bottom-width: 1px;
              border-bottom-color: rgba(0, 0, 0, 0.42);
            "
          ></div>
        </v-col>
        <v-col cols="5" class="pr-1">
          <v-text-field
            dense
            label="Full Name:"
            id="FullNameTextField"
            v-model="loanApplication.fullName"
            type="string"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            label="Date of first repayment:"
            v-model="loanApplication.repaymentDate"
            type="string"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <span class="text-body-2 font-weight-bold">PART 5: AGREEMENT</span>
        </v-col>
        <v-col cols="6">
          <span class="text-caption"
            >which includes Debit order authorization DEBICHECK</span
          >
        </v-col>
      </v-row>
      <v-row no-gutters class="pb-1">
        <v-col cols="12" style="text-align: justify; line-height: 7px">
          <span style="font-size: 7px">
            The Borrower herewith applies in the language of his / her choice.
            The Borrower herewith applies for the above selected loan and
            authorizes herewith irrevocably the Employer to deduct the amount
            and number of monthly repayments from his /her salary until the loan
            has been settled. The Borrower accepts that the Credit Provider may
            request & obtain any financial information about the Borrower on
            record from the National Credit Register & Credit Bureau & accepts
            that this loan will be listed on Credit Bureau. The Borrower hereby
            agrees that in the event of him/her leaving and there is an
            outstanding amount due on the loan, Bradbury Finance has the
            Borrower’s authorization to debit the Borrower’s bank account with
            the outstanding due. The Credit Provider shall consider the
            application and if approved, pay the amount of the loan directly
            into the Borrower’s designated bank account. The Employer of the
            Borrower undertakes to deduct the monthly repayment from the
            Borrower’s salary & pay same over to the Credit Provider's nominated
            account at the end of every month. In the event of the Borrower’s
            employment being terminated, for whatever reason, the Borrower
            hereby authorizes Credit Provider to issue and deliver debit order
            payment instructions to the Borrower’s banker for collection against
            my above-mentioned account and Bank indicated above on condition
            that the sum of each payment instruction and frequency of payment
            requests will never exceed the obligations as agreed and defined in
            the Agreement specified. The Borrower can only service the
            obligations defined in here if the payment instructions are executed
            as close as possible to when I receive my salary or wages which
            dates vary from month to month, especially during December of each
            year. To curb against (1) unpaid bank charges (2) losing the
            benefits described in the agreement quoted (3) incurring penalties
            due to non-payment; the Borrower explicitly authorize Credit
            Provider to utilize the functionality of Tracing supported on the
            DEBICHECK Payment Stream. Tracking supported on the DEBICHECK
            Payment Stream has been explained to me and I acknowledge that my
            above-mentioned account will be interrogated for a defined period
            until this period has lapsed or until payment was received. The
            Borrower hereby agree that in instances of an unpaid item, Credit
            Provider may submit the arrear payment together with a further due
            payment in any payment cycle or frequency as indicated above. The
            Borrower hereby agrees that subsequent payment instructions will
            continue to be delivered in terms of this authority until all
            obligations have been paid. This authorization will remain in force
            until cancelled by me in writing. The Borrower hereby acknowledges
            that my bank will charge fees to my account as agreed with them once
            they process this instruction. In terms of section 40(1) of the
            National Credit Act 34 of 2005 read with the threshold prescribed in
            terms of section 42(1) of the Act, registration as a credit provider
            is required if the total principal debt owed to the credit provider
            (or any associated person) in terms of all current credit agreements
            (other than incidental credit agreements) exceeds R500 000. The
            Borrower must pay interest at the rate declared on the first page of
            this contract. The interest must be paid together with the repayment
            of the capital sum of the loan at the conclusion of the loan period.
            The Borrower expressly renounces the benefits of the exceptio non
            numeratae pecuniae (the defence that the money has not been paid)
            and confirms that he/she understands the meaning of this exception
            and the effect of its renunciation. If repayment is made by way of
            monthly instalments, all payments must be made by the Borrower on or
            before the third business day of every month at (address at which
            payment must be made) or such other address as the lender may at a
            later stage advise in writing. If the Borrower fails to pay any
            instalment on the due date, the Credit Provider can immediately
            claim the full balance of the loan together with interest up to the
            date of payment. No relaxation by the lender in enforcing the
            acceleration clause at any stage will amount to a waiver of the
            lender's rights in terms of that clause. The Borrower can pay larger
            instalments than prescribed, or can pay the full balance of capital
            and interest at any time prior before the prescribed dates for
            payment. In that event, interest will be calculated only up to the
            date of payment. The Borrower may settle this agreement at any time
            in terms of section 125 of the National Credit Act 34 of 2005 by
            paying the unpaid balance of the loan amount, unpaid interest
            charges and all other fees and charges up to the date of settlement.
            If the Borrower does not make payment of any instalment on the due
            date for the payment of that instalment and the Credit Provider
            decides to enforce the acceleration clause, the lender must first
            give written notice to the borrower calling upon him or her to make
            payment within (insert number) days, failing which the lender will
            immediately thereafter be entitled to claim payment of whatever is
            due in terms of this agreement. In terms of Section 123 of the
            National Credit Act 34 of 2005, the lender reserves the right to
            terminate (cancel) this loan agreement with the Borrower if the
            Borrower defaults in making payment of any of the agreed repayments
            due in terms of this agreement, and the lender may thereafter
            proceed in terms of Section 129(1)(b) and Section 130 of the
            National Credit Act, which may result in a court of law enforcing
            the repayment of the borrower's outstanding obligations in terms of
            this agreement and in the judgment of the court being recorded by
            credit bureau. In the event of a breach by the Borrower of this
            agreement, the Borrower consents to the grant by a court of
            competent jurisdiction of an emoluments attachment order in respect
            of the amount of the judgment debt pursuant to the provisions of the
            Magistrates' Courts Act 32 of 1944 governing such orders. 22. The
            full balance of the capital and interest shall become payable
            immediately upon sequestration of the Borrower's estate. The parties
            confirm that this contract contains the full terms of their
            agreement and that no addition to or variation of this contract will
            be of any force or effect unless reduced to writing and signed by
            both parties. The parties choose as their respective domicilia
            citandi et executandi. I hereby authorise Bradbury Finance Pty Ltd
            to issue and deliver debit order payment instructions to your banker
            for collection against my Account and Bank used by my employer to
            deposit my salaries/wages, which account may differ from the account
            specified above on condition that the sum of each payment
            instruction and frequency of payment requests will never exceed the
            obligations as agreed and defined in the Agreement specified. My
            bank’s participation in the relevant payment stream, the
            authentication mechanism used by me, and the relevant rules
            applicable to the payment streams will determine per repayment cycle
            the most suitable payment stream in order to fulfil the obligations
            as defined in the agreement. My authorisation is subject thereto
            that the same payment instruction may never be presented
            simultaneously in more than one payment stream during the same
            repayment cycle or, if unpaid in a payment stream selected to be
            represented in the same cycle in another payment stream. I can only
            service the obligations defined in here if the payment instructions
            are executed as close as possible to when I receive my salary or
            wages which dates vary from month to month, especially during
            December of each year. To curb against (1) unpaid bank charges (2)
            losing the benefits described in the agreement quoted (3) incurring
            penalties due to non-payment; I explicitly authorise Bradbury
            Finance Pty Ltd to utilise the functionality of Tracking supported
            on the Authenticated and EDO Payment Streams especially after
            unsuccessful attempts on the EFT Payment Stream. Tracking supported
            on the Authenticated and EDO Payment Streams has been explained to
            me and I acknowledge that my above-mentioned account will be
            interrogated for a defined period until this period has lapsed or
            until payment has been received. I hereby agree that subsequent
            payment instructions will continue to be delivered in terms of the
            authority until all obligations have been paid. This authorisation
            will remain in force until cancelled by me in writing. I hereby
            acknowledge that my bank will charge fees to my account as agreed
            with them once they process this instruction. I foresee that I may
            change my bank and bank account particulars reflected in here, in
            which instance I will notify the beneficiaries specified, or any new
            beneficiary, should the agreement be ceded or assigned to any third
            party. Should I however forget to notify the beneficiary or the
            assigned third party and if the beneficiary or the assigned third
            party obtain my new bank particulars, on my account, this mandate
            will not lapse. This issued mandate will cover the obtained bank
            information and the beneficiary and the assigned third party may
            attach such new information, to this signed document as annexure,
            and the attached annexure must be read together with this mandate,
            by my new bank.
          </span>
        </v-col>
      </v-row>
      <!-- <div style="top: 25px; margin-left: 92%; position: fixed">
        <v-btn
          width="36px"
          height="36px"
          v-if="loanApplication && loanApplication.expenses"
          icon
          @click="downloadPDF"
          style="background-color: #4caf50"
        >
          <v-icon color="white">mdi-download</v-icon>
        </v-btn>
      </div> -->
    </div>
  </v-container>
</template>

<script>
import {
  LoanPurposes,
  Expenses,
  Employee,
  LoanApplication,
  LoanType,
  Company,
  CompanyLoanType,
} from "@/models";
import { layout } from "@/mixins";
import { Storage } from "@aws-amplify/storage";
import { DataStore, syncExpression } from "aws-amplify";
import _ from "lodash";
// import jsPDF from "jspdf";

export default {
  mixins: [layout],
  name: "ViewSingleApplicationPrint",

  components: {},

  data: () => ({
    theme: "print",
    loanTypeHeaders: [],
    expenseHeaders: [
      { text: "Expense", value: "type", class: "grey lighten-2" },
      { text: "Amount", value: "amount" },
    ],
    valid: false,

    signaturePDF: false,
    loanPurposes: LoanPurposes,
    expenses: Expenses,
    signatureImage: null,
    signatureImageUrl: null,
    loanApplication: null,
    employee: {},
    loanType: {},
    loanApplicationExpenses: [],
    company: {},
  }),

  async beforeMount() {
    await this.getLoanApplication();
  },

  methods: {
    getHeaderPeriod() {
      const salaryFrequency = this.loanApplication.salaryFrequency;

      if (salaryFrequency === "Monthly") {
        return "Month";
      } else if (salaryFrequency === "Weekly") {
        return "Week";
      } else if (salaryFrequency === "Fortnightly") {
        return "Fortnight";
      }
    },

    async getLoanApplication() {
      try {
        await DataStore.stop();
        DataStore.configure({
          syncExpressions: [
            syncExpression(LoanApplication, () => {
              return (LoanApplication) =>
                LoanApplication.id("eq", this.$route.params.applicationId);
            }),
            syncExpression(Employee, () => {
              return (Employee) => Employee.id("eq", null);
            }),
            syncExpression(LoanType, () => {
              return (LoanType) => LoanType.id("eq", null);
            }),
            syncExpression(Company, () => {
              return (Company) => Company.id("eq", null);
            }),
            syncExpression(CompanyLoanType, () => {
              return (CompanyLoanType) => CompanyLoanType.id("eq", null);
            }),
          ],
        });
        await DataStore.start();

        // let signatureFile = null;

        this.subscription = DataStore.observeQuery(LoanApplication, (la) =>
          la.id("eq", this.$route.params.applicationId)
        ).subscribe(async (snapshot) => {
          const { items, isSynced } = snapshot;
          if (isSynced && items.length > 0) {
            this.loanApplication = _.cloneDeep(items[0]);
            this.loanApplicationExpenses = JSON.parse(
              this.loanApplication.expenses
            );
            this.signatureImage = await Storage.get(
              this.loanApplication.signatureImage,
              {
                level: "public",
              }
            );
            let signatureFileName =
              this.loanApplication.signatureImage.substring(
                this.loanApplication.signatureImage.lastIndexOf("/") + 1
              );
            if (signatureFileName.includes(".pdf")) {
              this.signaturePDF = true;
            } else {
              this.signaturePDF = false;

              // signatureFile = await Storage.get(
              //   this.loanApplication.signatureImage,
              //   {
              //     level: "public",
              //     download: true,
              //   }
              // );
              // console.log("signatureFile", signatureFile);
              // this.signatureImageUrl = URL.createObjectURL(signatureFile.Body);
              // const a = document.createElement("a");
              // a.href = url;
              // a.download = fileName || "download";
              // const clickHandler = () => {
              //   setTimeout(() => {
              //     URL.revokeObjectURL(url);
              //     a.removeEventListener("click", clickHandler);
              //   }, 150);
              // };
              // a.addEventListener("click", clickHandler, false);
              // a.click();
            }

            this.loanTypeHeaders = [
              {
                text: "Loan Amount",
                value: "randValue",
                class: "grey lighten-2",
              },
              {
                text: "Term",
                value: "periodNumber",
              },
              {
                text: "Initial fee once off",
                value: "adminFee",
                class: "grey lighten-2",
              },
              {
                text: "Interest",
                value: "totalInterest",
              },
              {
                text: "Credit life per month",
                value: "creditLifeFee",
                class: "grey lighten-2",
              },
              {
                text: "Service fee per month",
                value: "serviceCharge",
              },
              {
                text: `Payment per ${this.getHeaderPeriod()}`,
                value: "payment",
                class: "grey lighten-2",
              },
              {
                text: "Total Payment",
                value: "totalPayment",
              },
              {
                text: "For office use",
                value: "code",
                class: "grey lighten-2",
              },
            ];

            this.subscription.unsubscribe();
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // downloadPDF() {
    //   try {
    //     var pdf = new jsPDF();
    //     const element = document.getElementById("print");
    //     if (element) {
    //       console.log(element);
    //       pdf.html(element);
    //       pdf.save("page.pdf");
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // generatePdf(){
    //    var doc = new jsPDF('p', 'pt', 'A4');
    //      margins = {
    //         top: 80,
    //         bottom: 60,
    //         left: 40,
    //         width: 522
    //     };

    //   doc.fromHTML(this.$refs.printRef, margins.left, margins.top,{
    //     'width' : margins.width
    //   });

    //   doc.save('test.pdf');
    // },
  },
  computed: {
    screenWidth() {
      let width = this.$vuetify.breakpoint.width;
      return width;
    },
    doesSignatureImageExist() {
      if (this.signatureImage) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
#ExpenseTable > div > table > tbody > tr > td {
  /* padding: 0px; */
  height: 20px;
  font-size: 12px;
}

.v-input--checkbox {
  margin-top: 0 !important;
  padding-top: 0 !important;
  margin-left: -3px;
  height: 24px;
}

/* @media print { 
 .v-data-table {
  table-layout: fixed;
   font-size: 12px; 
  width: 100% !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
  font-size: 12px !important;
}
.v-data-table .v-data-table__mobile-row {
  display: table-cell;
}
.v-data-table__mobile-row__header {
  height: 50%;
}
.v-data-table__mobile-row {
  padding: 0 !important;
   display: table !important; 
}
.v-data-table__mobile-row__cell {
  text-align: left !important;
} 
 } */
</style>
